<template>
  <div class="modal fade" id="CollectionPayments" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-full" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-9 col-sm-5 col-lg-5 my-auto">
                <h5 class="modal-title" id="CollectionPaymentsLabel">Payments</h5>
              </div>
              <div class="col-3 col-sm-7 my-auto">
                <div>
                  <div>
                    <span>
                      <a class="close">
                        <i
                          class="far fa-times-circle fa-2x"
                          data-dismiss="modal"
                          aria-label="Close"
                        ></i>
                      </a>
                    </span>
                  </div>
                  <div>
                    <!-- <router-link :to="{ path: '/dashboard'}" target="_blank">
                                  <span class="fa-stack fa-2x fsm float-right">
                                      <i class="far fa-circle fa-stack-2x"></i>
                                      <i class="fas fa-external-link-alt fa-stack-1x"></i>
                                  </span>
                    </router-link>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-12">
                <div class="table-responsive-lg fh">
                  <b-table
                    id="collection_payments_table"
                    striped
                    :items="p"
                    :fields="paymentsFields"
                    :per-page="itemsPerPage"
                    :currentPage="currentPage"
                    :busy="isBusy"
                  >
                    <template v-slot:table-busy>
                      <b-row align-h="center">
                        <propagate-loader class="mb-3" :color="primaryColour" :size="16"></propagate-loader>
                      </b-row>
                    </template>
                    <template slot="CustomerReference" slot-scope="data">
                      <router-link
                        :to="{path: '/dashboard/' + data.item.AccountReference}"
                        target="_blank"
                        class="underline mr-2"
                      >{{data.item.AccountReference}}</router-link>
                      <!-- Below if statment may be unnecessary -->
                      <span v-if="data.item.hasOwnProperty('DdOrganisationId')">
                        <img
                          v-if="data.item.DdOrganisationId === 1"
                          src="@/assets/img/electricity_icon.png"
                          class="img-fit_inline"
                          alt="Electricity icon"
                        />
                        <img
                          v-if="data.item.DdOrganisationId === 2"
                          src="@/assets/img/gas_icon.png"
                          class="img-fit_inline"
                          alt="Gas icon"
                        />
                      </span>
                    </template>
                    <template slot="Type" slot-scope="data">{{wordSplit(data.item.Type)}}</template>
                    <template
                      slot="TransactionDate"
                      slot-scope="data"
                    >{{data.item.TransactionDate | moment("DD.MM.YY")}}</template>
                    <template slot="Description" slot-scope="data">{{data.item.Description}}</template>
                    <template slot="TransactionType" slot-scope="data">{{data.item.TransactionType}}</template>
                    <template slot="Amount" slot-scope="data">{{data.item.Amount | currency}}</template>
                    <template
                      slot="FailureTypeId"
                      slot-scope="data"
                    >{{wordSplit(data.item.FailureTypeId)}}</template>
                  </b-table>
                  <b-pagination
                    v-if="p"
                    class="my-auto d-flex justify-content-center align-items-center mx-auto"
                    v-model="currentPage"
                    :total-rows="p.length"
                    :per-page="itemsPerPage"
                    aria-controls="collection_run_table"
                    @change="updateDdOrganisationIds"
                  >
                    <template v-slot:first-text>
                      <i class="fas fa-angle-double-left fa-2x pointer"></i>
                    </template>
                    <template v-slot:prev-text>
                      <i class="fas fa-chevron-left fa-2x pointer"></i>
                    </template>
                    <template v-slot:next-text>
                      <i class="fas fa-chevron-right fa-2x pointer"></i>
                    </template>
                    <template v-slot:last-text>
                      <i class="fas fa-angle-double-right fa-2x pointer"></i>
                    </template>
                  </b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import moment from "moment";
import Vue from "vue";
import _filters from "@/mixins/filters.js";

export default {
  mixins: [_filters],
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 20,
      collectionPayments: null,
      activeService: {
        serial: 0,
      },
      paymentsFields: {
        CustomerReference: {
          lable: "Account Reference",
          class: "text-center",
        },
        Type: {
          label: "Type",
          class: "text-center",
        },
        TransactionDate: {
          // key: 'TransactionDate',
          label: "Transaction Date",
          class: "text-center",
        },
        Description: {
          // key: 'Source',
          label: "Payment Method",
          class: "text-center",
        },
        TransactionType: {
          // key: 'TransactionType',
          label: "Transaction Type",
          class: "text-center",
        },
        Amount: {
          // key: 'Amount',
          label: "Amount",
          class: "text-center",
        },
        FailureTypeId: {
          // key: 'FailureTypeId',
          label: "Status",
          class: "text-center",
        },
      },
    };
  },
  methods: {
    updateDdOrganisationIds(page) {
      for (
        let i = (page - 1) * this.itemsPerPage;
        i < (page + 1) * this.itemsPerPage && i < this.p.length;
        i++
      ) {
        if (!this.p[i].hasOwnProperty("DdOrganisationId")) {
          this.getDdOrganisationId(this.p[i]);
        }
      }
    },
    getDdOrganisationId(collectionPayment) {
      this.$http
        .get(
          `https://${Vue.config.honeycomb.ddbot.domain}/api/v1/lodgements?accountId=${collectionPayment.AccountId}`,
          { withCredentials: true }
        )
        .then((response) => {
          collectionPayment.DdOrganisationId = this.$_.find(response.data, item => {
            return item.hasOwnProperty('AccountId')
          }).DdOrganisationId

          // While ddbot is not deployed
          // collectionPayment.DdOrganisationId =
          //   this.$_.find(response.data, (item) => {
          //     return item.hasOwnProperty("AccountId");
          //   }).AccountId % 2
          //     ? 1
          //     : 2;
          this.$forceUpdate();
        });
    },
  },
  computed: {
    primaryColour() {
      return Vue.config.honeycomb.theme;
    },
    details() {
      return this.$store.state.finances.runDetails;
    },
    p() {
      return this.$store.state.finances.collectionPayments;
    },
    isBusy() {
      if (this.p === null) return true;
      return false

      // let hasLoadedAllDdOrganisationIds = true;

      // for (
      //   let i = (this.currentPage - 1) * this.itemsPerPage;
      //   i < this.currentPage * this.itemsPerPage && i < this.p.length;
      //   i++
      // ) {
      //   hasLoadedAllDdOrganisationIds = this.p[i].hasOwnProperty(
      //     "DdOrganisationId"
      //   )
      //     ? hasLoadedAllDdOrganisationIds
      //     : false;
      // }
      // return !hasLoadedAllDdOrganisationIds;
    },
  },
  watch: {
    p: function () {
      if (this.p) {
        this.updateDdOrganisationIds(1);
      } else {
        this.currentPage = 1;
      }
    },
  }
};
</script>

